import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';

interface MQ {
  [name: string]: BehaviorSubject<any>;
}

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  private subjects: MQ = {};
  constructor() {}

  publish(name: string, value: any): void {
    if (!this.subjects[name]) {
      this.subjects[name] = new BehaviorSubject(null);
    }
    this.subjects[name].next(value);
  }

  subscribe(name: string): Observable<any> {
    if (this.subjects[name]) {
    } else {
      this.subjects[name] = new BehaviorSubject(null);
    }
    return this.subjects[name]?.asObservable();
  }
}
